import {createDeleteSlice} from "../genericCrudSlice";
import {deleteMovementApi} from "../../api/entities/movements";

const deleteMovementSlice = createDeleteSlice('movements', deleteMovementApi);
export const {init} = deleteMovementSlice.actions;
export const {deleteEntity: deleteMovement} = deleteMovementSlice;
export default deleteMovementSlice.reducer;